import { render, staticRenderFns } from "./DanhGiaNDDTaoBaoCao.vue?vue&type=template&id=34f17e93&scoped=true"
import script from "./DanhGiaNDDTaoBaoCao.vue?vue&type=script&lang=ts"
export * from "./DanhGiaNDDTaoBaoCao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f17e93",
  null
  
)

export default component.exports